<template>
  
</template>

<script>
export default {
    methods:{
        matomo_fn(arr,page){
            if(this.$matomo){
                this.$matomo.deleteCustomVariables('page');
                this.$matomo.setCustomUrl(location.href)
                arr.forEach((element,index) => {
                    this.$matomo.setCustomVariable(index+1,element.key,element.value,'page');
                });
                this.$matomo.trackPageView(page);
            }
        }
    },
    mounted(){
    }
}
</script>

<style>

</style>